import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StudentState {
  studentId: string;
  fullName: string;
  studentEmail: string;
  schoolYear: number;
  rollNumber: string;
  educationLevel: string;
}

const initialState: StudentState = {
  studentId: "",
  fullName: "",
  studentEmail: "",
  schoolYear: 0,
  rollNumber: "",
  educationLevel: "",
};

const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    setStudentDetails: (state, action: PayloadAction<StudentState>) => {
      state.studentId = action.payload.studentId;
      state.fullName = action.payload.fullName;
      state.studentEmail = action.payload.studentEmail;
      state.schoolYear = action.payload.schoolYear;
      state.rollNumber = action.payload.rollNumber;
      state.educationLevel = action.payload.educationLevel;
    },
  },
});

export const { setStudentDetails } = studentSlice.actions;
export default studentSlice.reducer;
